import ChangeDown from "../../football/rules/general/downs/change-down";
import FirstDown from "../../football/rules/general/downs/first-down";
import FirstDownFlag from "../../football/rules/general/downs/flag-first-down";
import PlayEnd from "../../football/rules/general/play-end";
import PlayEndDown from "../../football/rules/general/play-end-down";
import GameStart from "../../football/rules/general/game-start";
import Timeout from "../../football/rules/general/timeout";
import Touchdown from "../rules/general/scoring/touchdown";
import KickOff from "../../football/rules/general/kick-off";
import FlagStartKickOff from "./general/kicks/flag-start-kick-off";
import FlagNextKickOff from "./general/kicks/flag-next-kickoff";
import KickOffDowned from "./general/kicks/kickoff-downed";
import KickOffStats from "../../football/rules/general/kicks/kickoff/kick-off-stats";
import KickOffReturnStats from "../../football/rules/general/kicks/kickoff-return/kickoff-return-stats";
import Onside from "../../football/rules/general/kicks/onside";
import KickOffPenaltyAccepted from "../../football/rules/general/kicks/kickoff/kick-off-penalty-accepted";
import KickOffPenaltyDeclined from "../../football/rules/general/kicks/kickoff/kick-off-penalty-declined";
import KickOffOutOfBounds from "../../football/rules/general/kicks/kickoff/kick-off-out-of-bounds";
import NoRecoveryKickReturn from "../../football/rules/general/kicks/no-recovery-kick-return";
import FairCatch from "../../football/rules/general/fair-catch";
import Returned from "../../football/rules/general/returned";
import OutofBoundsStats from "../../football/rules/defensive/out-of-bounds/out-of-bounds-stats";
import PatComplete from "./general/scoring/pat-complete";
import FlagPatDefenseComplete from "./general/scoring/pat-defense-complete";
import PatDefenseCompleteStats from "../../football/rules/general/scoring/pat-defense-complete-stats";
import PatTry from "../rules/offensive/pat/pat-try";
import PatRun from "../../football/rules/offensive/pat/pat-run";
import PatPass from "../../football/rules/offensive/pat/pat-pass";
import Continued from "../../football/rules/offensive/continued";
import PassAttemptStats from "../../football/rules/offensive/pass/attempt/pass-attempt-stats";
import PassCompleteStatsTouchdown from "../../football/rules/offensive/pass/complete/pass-complete-touchdown-stats";
import PassCompleteFieldChange from "../../football/rules/offensive/pass/complete/field-change";
import PassIncompleteStats from "../../football/rules/offensive/pass/incomplete/pass-incomplete-stats";
import PassSackedStats from "../../football/rules/offensive/pass/sack/pass-sack-stats";
import PassSackFieldChange from "../../football/rules/offensive/pass/sack/field-change";
import PassInterceptionStats from "../../football/rules/offensive/pass/interception/pass-interception-stats";
import PassInterceptionFieldChange from "../../football/rules/offensive/pass/interception/field-change";
import PassInterceptionStatsTouchdown from "../../football/rules/offensive/pass/interception/pass-interception-touchdown-stats";
import RushStats from "../../football/rules/offensive/rush/rush-stats";
import RushFieldChange from "../../football/rules/offensive/rush/rush-field-change";
import TackleStats from "../../football/rules/defensive/tackle/tackle-stats";
import ResetField from "../../football/rules/general/reset-field";
import Lateral from "../../football/rules/offensive/lateral";
import SafetyPunt from "../../football/rules/defensive/safety/safety-punt";
import FlagSafety from "./defensive/safety/safety";
import FlagSafetyRecordStats from "./defensive/safety/safety-stats";
import SpikeStats from "../../football/rules/offensive/spike-stats";
import FumbledSnapPossession from "./offensive/fumbled-snap-possession";
import DeadBallFieldChange from "./offensive/dead-ball-field-change";

//Special Teams
import PuntStatsPunter from "../../football/rules/specialteams/punt/punter-stats";
import PuntFieldChangeNoReturn from "../../football/rules/specialteams/punt/no-return/field-change";
import PuntFieldChangeReturn from "../../football/rules/specialteams/punt/return/field-change";
import PuntReturnerStats from "../../football/rules/specialteams/punt/return/punt-returner-stats";
import PuntTouchbackStatsPunter from "../../football/rules/specialteams/punt/touchback/touchback-punter-stats";
import PatFail from "./offensive/pat/pat-fail";
import AddToDrive from "../../football/rules/general/drives/add-to-drive";
import CreateDrive from "../rules/general/drives/create-drive";
import SetTimeOnPlay from "../../football/rules/general/set-time-on-play";
import PenaltyAccepted from "../../football/rules/general/penalty/penalty-accepted";
import UpdateContext from "../../football/rules/general/update-context";
import SwapTeams from "../../football/rules/general/swap-teams";
import SetTimeAndPeriod from "../../football/rules/general/set-time-and-period";
import OvertimeDrive from "../../football/rules/general/overtime-drive";
import ExtraOvertime from "../../football/rules/general/extra-overtime";
import PeriodStart from "../../football/rules/general/period-start";
import CoinToss from "../../football/rules/general/coin-toss";
import OvertimeOpensWithDrive from "../../football/rules/general/overtime-opens-with-drive";
import OvertimeOpensWithKickoff from "../../football/rules/general/overtime-opens-with-kickoff";
import PuntBlockedStats from "../../football/rules/specialteams/punt/blocked/punt-blocked-stats";
import PuntBlockedRecovery from "../../football/rules/specialteams/punt/blocked/punt-blocked-recovery";
import Turnover from "../../football/rules/general/turnover";
import PenaltyAcceptedStats from "../../football/rules/general/penalty/penalty-accepted-stats";
import FlagPatCompleteStats from "./general/scoring/pat-complete-stats";
import AwardFirstDown from "../../football/rules/general/downs/award-first-down";
import ChangeDownStats from "../../football/rules/general/downs/change-down-stats";
import CountTouchdownsAsFirstDownsRule from "../../football/rules/general/downs/count-touchdowns-as-first-downs-rule";
import ContinuedStats from "../../football/rules/offensive/continued-stats";
import LateralStats from "../../football/rules/offensive/lateral-stats";
import FlagPatPassStats from "./offensive/pat/pat-pass-stats";
import FlagPatRunStats from "./offensive/pat/pat-run-stats";
import PassCompleteReceiverStats from "../../football/rules/offensive/pass/complete/pass-complete-receiver-stats";
import QuarterbackStats from "../../football/rules/offensive/pass/complete/quarterback-stats";
import FumbleStats from "../../football/rules/offensive/fumble/fumble-stats";
import FumbleRecovery from "../../football/rules/offensive/fumble/fumble-recovery";
import FumbleRecoveryStats from "../../football/rules/offensive/fumble/fumble-recovery-stats";
import RushTouchdownStats from "../../football/rules/offensive/rush/rush-touchdown-stats";
import PuntReturnTouchdownStats from "../../football/rules/specialteams/punt/return/punt-return-touchdown-stats";
import PuntNoRecoveryReturnerStats from "../../football/rules/specialteams/punt/return/punt-no-recovery-returner-stats";
import SafetyFieldSetup from "./general/safety-field-setup";
import FumbleRecoveryTouchdownStats from "../../football/rules/offensive/fumble/fumble-recovery-touchdown-stats";
import CollectDriveTime from "../../football/rules/general/drives/collect-drive-time";
import KneelDownStats from "../../football/rules/offensive/kneeldown-stats";
import KneelDown from "../../football/rules/offensive/kneeldown";
import TouchBack from "../../football/rules/general/touchback";
import IsRegularGameRule from "../../football/rules/general/is-regular-game-rule";
import IsPatGameRule from "../../football/rules/general/is-pat-game-rule";
import StartGame from "../../football/rules/general/start-game";
import StatsCountRule from "./general/stats-count-rule";
import EndDrive from "../../football/rules/general/drives/end-drive";
import UpdateContextStats from "../../football/rules/general/update-context-stats";
import ContinueTouchdownStats from "../../football/rules/offensive/continue-touchdown-stats";
import Finalize from "../../football/rules/general/finalize";

const FlagFootballRules = Object.freeze({
    General: Object.freeze({
        KickOff: new KickOff(),
        StartKickOff: new FlagStartKickOff(),
        NextKickOff: new FlagNextKickOff(),
        Kicks: Object.freeze({
            RecordStatsKickOff: new KickOffStats(),
            RecordStatsKickOffReturn: new KickOffReturnStats(),
            Onside: new Onside(),
            Downed: new KickOffDowned(),
            KickOffPenaltyAccepted: new KickOffPenaltyAccepted(),
            KickOffPenaltyDeclined: new KickOffPenaltyDeclined(),
            KickOffOutOfBounds: new KickOffOutOfBounds(),
            NoRecoveryKickReturn: new NoRecoveryKickReturn()
        }),
        FairCatch: new FairCatch(),
        Returned: new Returned(),
        PlayEnd: Object.freeze({
            Default: new PlayEnd(),
            Down: new PlayEndDown()
        }),
        Finalize: new Finalize(),
        AwardFirstDown: new AwardFirstDown(),
        ChangeDownStats: new ChangeDownStats(),
        CountTouchdownsAsFirstDowns: new CountTouchdownsAsFirstDownsRule(),
        ChangeDown: new ChangeDown(),
        FirstDown: new FirstDown(),
        FlagFirstDown: new FirstDownFlag(),
        SetTimeOnPlay: new SetTimeOnPlay(),
        StartGame: new StartGame(),
        Drive: Object.freeze({
            AddPlay: new AddToDrive(),
            Create: new CreateDrive(),
            CollectTime: new CollectDriveTime(),
            EndDrive: new EndDrive()
        }),
        Scoring: Object.freeze({
            Touchdown: new Touchdown(),
            Pat: Object.freeze({
                Try: new PatTry(),
                Complete: new PatComplete(),
                CompleteStats: new FlagPatCompleteStats(),
                DefenseComplete: new FlagPatDefenseComplete(),
                DefenseCompleteStats: new PatDefenseCompleteStats(),
                Run: new PatRun(),
                RunStats: new FlagPatRunStats(),
                Pass: new PatPass(),
                PassStats: new FlagPatPassStats(),
                Fail: new PatFail()
            })
        }),
        ResetField: new ResetField(),
        SafetyFieldSetup: new SafetyFieldSetup(),
        GameStart: new GameStart(),
        Timeout: new Timeout(),
        UpdateContext: new UpdateContext(),
        UpdateContextStats: new UpdateContextStats(),
        SwapTeams: new SwapTeams(),
        SetTimeAndPeriod: new SetTimeAndPeriod(),
        Penalty: Object.freeze({
            Accepted: new PenaltyAccepted(),
            AcceptedStats: new PenaltyAcceptedStats()
        }),
        StartPeriod: new PeriodStart(),
        OvertimeDrive: new OvertimeDrive(),
        ExtraOvertime: new ExtraOvertime(),
        CoinToss: new CoinToss(),
        OvertimeOpensWithDrive: new OvertimeOpensWithDrive(),
        OvertimeOpensWithKickoff: new OvertimeOpensWithKickoff(),
        Turnover: new Turnover(),
        TouchBack: new TouchBack(),
        IsRegularGame: new IsRegularGameRule(),
        IsPatGame: new IsPatGameRule(),
        StatsCount: new StatsCountRule()
    }),
    Offensive: Object.freeze({
        Continued: new Continued(),
        ContinuedStats: new ContinuedStats(),
        FumbledSnapPossession: new FumbledSnapPossession(),
        DeadBallFieldChange: new DeadBallFieldChange(),
        Fumble: Object.freeze({
            RecordStats: new FumbleStats(),
            Recovery: new FumbleRecovery(),
            RecoveryStats: new FumbleRecoveryStats(),
            RecordStatsTouchdown: new FumbleRecoveryTouchdownStats()
        }),
        Pass: Object.freeze({
            Attempt: Object.freeze({
                RecordStats: new PassAttemptStats()
            }),
            Complete: Object.freeze({
                RecordStatsReceiver: new PassCompleteReceiverStats(),
                FieldChange: new PassCompleteFieldChange(),
                RecordStatsQuarterback: new QuarterbackStats(),
                RecordStatsTouchdown: new PassCompleteStatsTouchdown()
            }),
            Incomplete: Object.freeze({
                RecordStats: new PassIncompleteStats()
            }),
            Interception: Object.freeze({
                RecordStats: new PassInterceptionStats(),
                FieldChange: new PassInterceptionFieldChange(),
                RecordStatsTouchdown: new PassInterceptionStatsTouchdown()
            }),
            Sacked: Object.freeze({
                RecordStats: new PassSackedStats(),
                FieldChange: new PassSackFieldChange()
            })
        }),
        SpikeStats: new SpikeStats(),
        Rush: Object.freeze({
            RecordStats: new RushStats(),
            FieldChange: new RushFieldChange(),
            RecordStatsTouchdown: new RushTouchdownStats(),
            ContinueTouchdownStats: new ContinueTouchdownStats()
        }),
        Lateral: new Lateral(),
        LateralStats: new LateralStats(),
        KneelDownStats: new KneelDownStats(),
        KneelDown: new KneelDown()
    }),
    Defensive: Object.freeze({
        Tackle: Object.freeze({
            RecordStats: new TackleStats()
        }),
        OutOfBounds: Object.freeze({
            RecordStats: new OutofBoundsStats()
        }),
        Safety: Object.freeze({
            Punt: new SafetyPunt(),
            Complete: new FlagSafety(),
            RecordStats: new FlagSafetyRecordStats()
        })
    }),
    SpecialTeams: Object.freeze({
        Punt: Object.freeze({
            RecordStatsPunter: new PuntStatsPunter(),
            NoReturn: Object.freeze({
                FieldChange: new PuntFieldChangeNoReturn()
            }),
            Return: Object.freeze({
                FieldChange: new PuntFieldChangeReturn(),
                RecordStats: new PuntReturnerStats(),
                RecordStatsTouchdown: new PuntReturnTouchdownStats(),
                PuntNoRecoveryReturnerStats: new PuntNoRecoveryReturnerStats()
            }),
            TouchBack: Object.freeze({
                RecordStats: new PuntTouchbackStatsPunter()
            }),
            Blocked: Object.freeze({
                Recovery: new PuntBlockedRecovery(),
                RecordStats: new PuntBlockedStats()
            })
        })
    })
});

export default FlagFootballRules;
